export class Comment {
  uid = '';
  createdAt: Date = new Date();
  comment?: string = undefined;
  creatorUID?: string = undefined;

  public constructor(init?: Partial<Comment>) {
    const defaults = {
      createdAt: new Date().toISOString(),
      uid: null,
      content: '',
      creatorUID: '',
    };

    Object.assign(this, defaults, init);
  }
}
